const initialState = { reAuthKey: 0 };

export default function reAuthReducer(state = initialState, action) {
  switch (action.type) {
    case 'REAUTH_SUCCESS':
      return { reAuthKey: state.reAuthKey + 1 };
    default:
      return state;
  }
}